import cn from 'classnames';
import styles from './Socials.module.scss';
import {Link} from "../Link/Link";

const socials = [
    {id: 0, link: 'https://vk.com/2x2tv', sharing: `https://vk.com/share.php?url=${window.location.href}&title=КИБЕРКРИНЖ 2x2`, text: 'ВК'},
    {id: 1, link: 'https://ok.ru/2x2tv', sharing: `https://connect.ok.ru/offer?url=${window.location.href}&title=КИБЕРКРИНЖ 2x2`, text: 'ОК'},
    {id: 2, link: 'https://t.me/telekanal2x2', sharing: `https://t.me/share/url?url=${window.location.href}&text=КИБЕРКРИНЖ 2x2`, text: 'Телега'}
];

export const Socials = ({className, footer = false}) => {
    const socialsList = socials.map(item => {
        const {id, link, sharing, text} = item;

        return (
            <li className={styles.item} key={id}>
                <Link link={!footer ? sharing : link} text={text} className={cn(styles.link, "body", "soc")}/>
            </li>
        )
    });

    return (
        <ul className={cn(styles.socials, className)}>
            {socialsList}
        </ul>
    )
}